import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6 bg-zinc-800/50 rounded-xl p-4 border-white/5"
}
const _hoisted_2 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "font-semibold text-white" }
const _hoisted_6 = { class: "text-xs text-zinc-400" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "flex justify-between items-center text-xs" }
const _hoisted_9 = { class: "text-emerald-400 font-medium" }
const _hoisted_10 = { class: "h-2 bg-zinc-700/50 rounded-full overflow-hidden" }
const _hoisted_11 = { class: "flex justify-between items-center text-xs" }
const _hoisted_12 = { class: "text-zinc-400" }
const _hoisted_13 = { class: "text-zinc-400" }

import { computed, ref, watchEffect } from 'vue'

// Simulando o valor da comissão total (substitua pelo valor real do localStorage)

export default /*@__PURE__*/_defineComponent({
  __name: 'UserProgressCard',
  setup(__props) {

const totalCommissionValue = localStorage.getItem('totalCommission') || '0'
const totalCommission = ref(parseFloat(totalCommissionValue))

const awards = [
  {
    id: '1',
    title: 'Primeiro Marco',
    subtitle: 'Placa de 50K',
    imageUrl: '/img/awards/BOT - 50k.png',
    value: '50K',
    targetAmount: 50000,
    nextMilestone: '100 Mil',
    minAmount: 0,
    maxAmount: 50000
  },
  {
    id: '2',
    title: 'Mestre',
    subtitle: 'Placa de 100K',
    imageUrl: '/img/awards/BOT - 100k.png',
    value: '100K',
    targetAmount: 100000,
    nextMilestone: '500 Mil',
    minAmount: 50000,
    maxAmount: 100000
  },
  {
    id: '3',
    title: 'Elite',
    subtitle: 'Placa de 500K',
    imageUrl: '/img/awards/BOT - 500k.png',
    value: '500K',
    targetAmount: 500000,
    nextMilestone: '1 Milhão',
    minAmount: 100000,
    maxAmount: 500000
  },
  {
    id: '4',
    title: 'Lenda',
    subtitle: 'Placa de 1M',
    imageUrl: '/img/awards/BOT - 1M.png',
    value: '1M',
    targetAmount: 1000000,
    nextMilestone: '5 Milhões',
    minAmount: 500000,
    maxAmount: Infinity
  }
];

// Seleciona o prêmio adequado automaticamente
const selectedBot = ref(null)

watchEffect(() => {
  // Encontra o prêmio mais adequado baseado no valor da comissão
  const suitableAward = awards.find(award => 
    totalCommission.value >= award.minAmount && totalCommission.value < award.maxAmount
  ) || awards[awards.length - 1] // Fallback para o último prêmio se ultrapassar todos
  
  selectedBot.value = {
    ...suitableAward,
    currentAmount: totalCommission.value
  }
})

const isOpen = ref(true)

// Calcula a porcentagem de progresso
const progressPercentage = computed(() => {
  if (!selectedBot.value) return 0
  const percentage = (selectedBot.value.currentAmount / selectedBot.value.targetAmount) * 100
  return Math.min(100, percentage.toFixed(2)) // Limita a 100% e formata com 2 casas decimais
})

// Formata os valores monetários
const formattedCurrentAmount = computed(() => {
  if (!selectedBot.value) return '0,00'
  return selectedBot.value.currentAmount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

const formattedTargetAmount = computed(() => {
  if (!selectedBot.value) return '0,00'
  return selectedBot.value.targetAmount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

return (_ctx: any,_cache: any) => {
  return (isOpen.value && selectedBot.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "max-h-[4rem]",
              src: selectedBot.value.imageUrl,
              alt: selectedBot.value.title
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(selectedBot.value.title), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(selectedBot.value.subtitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-zinc-400" }, "Faturamento", -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(progressPercentage.value) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "h-full bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full",
              style: _normalizeStyle(`width: ${progressPercentage.value}%`)
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, "R$ " + _toDisplayString(formattedCurrentAmount.value), 1),
            _createElementVNode("span", _hoisted_13, "Meta: R$ " + _toDisplayString(formattedTargetAmount.value), 1)
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'awards' }))),
            class: "w-full mt-1 text-xs text-center py-1.5 rounded-md bg-zinc-700/50 hover:bg-zinc-700 text-zinc-300 transition-colors"
          }, " Ver premiações ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})